export function printInvoiceA4(invoiceData, formatNumber, t) {
  // Create a hidden iframe for printing
  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";

  document.body.appendChild(iframe);

  // Helper function to dynamically generate table rows
  const generateTableRows = (items, columns) => {
    return items
      .map((item, index) => {
        // Dynamically create a <td> for each column name provided
        const rowCells = columns
          .map((column) => {
            // Handle the special case for the '#' column
            if (column === "#") {
              return `<td>${index + 1}</td>`;
            }
            // Access the value using the column name as the key
            return `<td>${item[column]}</td>`;
          })
          .join("");

        const hasDiscount = invoiceData.summary.discount > 0;

        // Construct the full row, including the discount and total columns
        return `
        <tr>
          ${rowCells}
          ${hasDiscount ? `<td>${formatNumber(item.discount || 0)}</td>` : ``}
     
        </tr>
      `;
      })
      .join("");
  };

  // Helper function to dynamically generate table headers
  const generateTableHeaders = (columns) => {
    return columns
      .map(
        (column) => `
      <th>${t(column)}</th>
    `
      )
      .join("");
  };

  const invoiceContent = `
    <html>
    <head>
      <title>${t(invoiceData.invoiceTitle)}</title>
      <style>
        @font-face {
          font-family: 'kurd';
          src: url('https://storage.wisesale.app/Rabar_022-Busi21Jx.ttf') format('truetype');
        }

        body {
          font-family: 'kurd', sans-serif;
          direction: rtl;
          text-align: right;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
          background: white;
          margin: 0;
        }

        @page {
          size: A4;
          margin: 15mm;
        }
        
        .my_font { font-family: 'kurd' !important; }

        .invoice-container {
          max-width: 210mm;
          margin: 0 auto;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
          padding: 10mm;
        }

        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 20px;
          
        }
          .headerBorder{
          border-bottom: 2px solid #eee;}
        .header h1 {
          font-size: 28px;
          color: #7165E3;
          margin: 0;
        }
        .header p {
          margin: 0;
          font-size: 12px;
          color: #777;
        }
        .header .company-info {
          text-align: right;
        }

        .summary-box {
          margin-top: 20px;
          background: #f2f2f2;
          padding: 10px;
          border-radius: 5px;
          line-height: 1.5;
        }
        .summary-box h3 {
          margin: 6px 0;
          font-size: 16px;
          font-weight: bold;
          color: #7165E3;
        }
        .summary-box h4 {
          margin: 4px 0;
          font-size: 14px;
        }
        .summary-box .debt {
          color: red;
        }
        
        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 20px;
        }
        th, td {
          border: 1px solid #eee;
          padding: 4px;
          text-align: center;
          font-size: 14px;
        }
        th {
          background-color: #7165E3;
          color: white;
        }
        tr:nth-child(even) {
          background-color: #f9f9f9;
        }

        .footer {
          margin-top: 40px;
          text-align: center;
          font-size: 14px;
        }
      </style>
    </head>
    <body>
      <div class="invoice-container">
        <!-- HEADER -->
        <div class="header headerBorder">
          <div class="company-info">
            <h1>${invoiceData.companyInfo.appName}</h1>
         
            <p>${t("phone number")}: ${
    invoiceData.companyInfo.phoneNumber +
    (invoiceData.companyInfo.phoneNumber2 != "" &&
    invoiceData.companyInfo.phoneNumber2 != null
      ? " - " + invoiceData.companyInfo.phoneNumber2
      : "")
  }</p>
              <p>${t("address")}: ${invoiceData.companyInfo.address}</p>
          </div>
        <!--   <div class="company-logo">
            <img src="${
              invoiceData.companyInfo.logoUrl
            }" alt="Company Logo" style="max-width: 100px; max-height: 100px;">
          </div> -->
          <div>
            <h1 style="color: #333; font-size: 20px;">${t(
              invoiceData.headerMessage
            )}</h1>
          
            <p><strong>${t("date")}:</strong> ${invoiceData.invoiceDate}</p>  
          </div>
        </div>
         <div class="header">
<h2 style="color: #333; font-size: 18px;">${
    t(invoiceData.name_var) + " : " + invoiceData.id + " - " + invoiceData.name
  }</h2>
  <h2 style="color: #333; font-size: 16px;">${
  t('date')+' : ' + invoiceData.startDate + " - " + invoiceData.endDate
  }</h2>
  </div>
          <div class='header'>

        <div style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <div style="; background-color: #f2f2f2; padding: 15px; border-radius: 5px; border: 1px solid #ddd; box-sizing: border-box;">
            <div style="display: flex; justify-content: space-between; padding: 4px 0;">
              <span style="font-size: 17px; font-weight: normal; color: #555;">${t(
                "dollar_debt"
              )}:</span>
              <span style="font-size: 20px; font-weight: bold; color: #333;">  ${
                formatNumber(invoiceData.summary.debtDollar) +
                t("dollar")
              }</span>
            </div>

            <div style="display: flex; justify-content: space-between; padding: 4px 0; font-size: 18px; color: #333;">
              <span style=" color: #555;">${t("dinar_debt")}:</span>
              <span style="font-size: 20px; font-weight: bold;">${
                formatNumber(invoiceData.summary.debtDinar) +
                t("dinar")
              }</span>
            </div>

          </div>
        </div>
        </div>
        <!-- LINE ITEMS TABLE -->
        <table>
          <thead>
            <tr>
              ${generateTableHeaders(invoiceData.tableColumns)}
          
          
            </tr>
          </thead>
          <tbody>
            ${generateTableRows(invoiceData.items, invoiceData.tableColumns)}
          </tbody>
        </table>

  
      
    <!-- SUMMARY SECTION -->


        <!-- FOOTER -->
       
      </div>
    </body>
    </html>
  `;

  // Write the generated HTML to the iframe
  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(invoiceContent);
  doc.close();

  // Wait a moment before printing
  iframe.onload = () => {
    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
       // Cleanup
    }, 50); // slight delay ensures content is loaded
  };
}

// You would call the function like this:
// printInvoiceA4(sampleData, formatNumber, t);
//
// You will need to define your own formatNumber and t functions in your code.
// E.g.,
// function formatNumber(num) {
//   return new Intl.NumberFormat().format(num);
// }
// function t(key) {
//   // Your translation logic here
//   const translations = {
//     invoice_title: 'Invoice',
//     invoice_title_name: 'Sales Invoice',
//     // ... other translations
//   };
//   return translations[key] || key;
// }
